export default {
  SET_LANGUAGE: '@@language/SET_LANGUAGE',
  FETCH_LANGUAGES_REQUEST: '@@language/FETCH_LANGUAGES_REQUEST',
  FETCH_LANGUAGES_SUCCESS: '@@language/FETCH_LANGUAGES_SUCCESS',
  FETCH_LANGUAGES_ERROR: '@@language/FETCH_LANGUAGES_ERROR',
  FETCH_TRANSLATIONS_REQUEST: '@@language/FETCH_TRANSLATIONS_REQUEST',
  FETCH_TRANSLATIONS_SUCCESS: '@@language/FETCH_TRANSLATIONS_SUCCESS',
  FETCH_TRANSLATIONS_ERROR: '@@language/FETCH_TRANSLATIONS_ERROR',
};
